"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = exports.getDynamicFlow = exports.parseFormData = exports.getOneOf = exports.immuteArray = exports.immute = exports.FeedbackInstance = exports.FeedbackSDK = exports.QuestionsMatrix = exports.Module = exports.Base = exports.CompanyEvent = exports.Poll = exports.ThemeValues = void 0;
const index_1 = __importDefault(require("./sdk/index"));
exports.FeedbackSDK = index_1.default;
const Poll_1 = __importDefault(require("./sdk/models/Poll"));
exports.Poll = Poll_1.default;
const Base_1 = __importDefault(require("./sdk/models/Base"));
exports.Base = Base_1.default;
const CompanyEvent_1 = __importDefault(require("./sdk/models/CompanyEvent"));
exports.CompanyEvent = CompanyEvent_1.default;
const EventEmitter_1 = __importDefault(require("./sdk/EventEmitter"));
exports.EventEmitter = EventEmitter_1.default;
const Module_1 = __importDefault(require("./sdk/models/Module"));
exports.Module = Module_1.default;
const QuestionsMatrix_1 = __importDefault(require("./sdk/models/QuestionsMatrix"));
exports.QuestionsMatrix = QuestionsMatrix_1.default;
const FeedbackInstance_1 = __importDefault(require("./sdk/FeedbackInstance"));
exports.FeedbackInstance = FeedbackInstance_1.default;
const payload_1 = require("./sdk/utils/payload");
Object.defineProperty(exports, "immute", { enumerable: true, get: function () { return payload_1.immute; } });
Object.defineProperty(exports, "immuteArray", { enumerable: true, get: function () { return payload_1.immuteArray; } });
const hidash_1 = require("./sdk/utils/hidash");
Object.defineProperty(exports, "getOneOf", { enumerable: true, get: function () { return hidash_1.getOneOf; } });
const core_1 = require("./sdk/utils/core");
Object.defineProperty(exports, "parseFormData", { enumerable: true, get: function () { return core_1.parseFormData; } });
Object.defineProperty(exports, "getDynamicFlow", { enumerable: true, get: function () { return core_1.getDynamicFlow; } });
const types_1 = require("./sdk/types");
Object.defineProperty(exports, "ThemeValues", { enumerable: true, get: function () { return types_1.ThemeValues; } });
const feedbackSDK = new index_1.default();
exports.default = feedbackSDK;
